import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ark-ui-blur',
  templateUrl: './ui-blur.component.html',
  styleUrls: ['./ui-blur.component.scss'],
})
export class UiBlurComponent {
  @Input() blured = false;
  constructor() {}
}
